const LOAD_LOCALES = 'react-template/api/locales/LOAD_LOCALES'
const LOAD_LOCALES_SUCCESS = 'react-template/api/locales/LOAD_LOCALES_SUCCESS'
const LOAD_LOCALES_FAIL = 'react-template/api/locales/LOAD_LOCALES_FAIL'

const LOAD_REGISTRATION_LOCALES = 'react-template/api/locales/LOAD_REGISTRATION_LOCALES'
const LOAD_REGISTRATION_LOCALES_SUCCESS = 'react-template/api/locales/LOAD_REGISTRATION_LOCALES_SUCCESS'
const LOAD_REGISTRATION_LOCALES_FAIL = 'react-template/api/locales/LOAD_REGISTRATION_LOCALES_FAIL'

const initialState = {
  loaded: false,
  data: [],
  registration: {}
}

export default function locales(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_LOCALES:
      return {
        ...state,
        loading: true,
      }

    case LOAD_LOCALES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        data: [...action.result],
      }

    case LOAD_LOCALES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      }
    case LOAD_REGISTRATION_LOCALES:
      return {
        ...state,
        registration: {
          loading: true
        }
      }

    case LOAD_REGISTRATION_LOCALES_SUCCESS:
      return {
        ...state,
        registration: {
          loading: false,
          loaded: true,
          error: null,
          data: [...action.result.list],
        }
      }

    case LOAD_REGISTRATION_LOCALES_FAIL:
      return {
        ...state,
        registration: {
          loading: false,
          loaded: false,
          error: action.error,
        }
      }
    default:
      return state
  }
}

export function isLoaded(globalState) {
  return globalState.locales && globalState.locales.loaded
}

export function loadLocales() {
  return {
    types: [LOAD_LOCALES, LOAD_LOCALES_SUCCESS, LOAD_LOCALES_FAIL],
    promise: client =>
      client.get('api/translation-locales', {
        removeToken: true,
      }),
  }
}

export function loadRegistrationLocales(orgId) {
  return {
    types: [LOAD_REGISTRATION_LOCALES, LOAD_REGISTRATION_LOCALES_SUCCESS, LOAD_REGISTRATION_LOCALES_FAIL],
    promise: client =>
      client.post(`apiv2/registration/locale/organization/${orgId}/list`, {
        removeToken: true,
      }),
  }
}

